/** Module-level flag: true while AI is generating a response in JobPage. */
export const processingState = { isProcessing: false };
